import React from "react";
import Link from "@components/Link";
import { useFetchChapterSlug } from "../../hooks";

const HeaderNavChapter = () => {
	const { mainLinks } = useFetchChapterSlug();

	if (!mainLinks) return <></>;

	return (
		<>
			{mainLinks.map((item: any, index: number) => (
				<Link
					key={index}
					to={`/${item?.slug}`}
					className={`HeaderNav--item--link ${
						index === 1 || index === 2
							? "HeaderNav--item--link--hidden"
							: ""
					}`}
					activeClassName="is-active"
				>
					{item?.navLabel}
				</Link>
			))}
		</>
	);
};

export default HeaderNavChapter;
